<template>
	<FooterBar
		:link-items="linkItems"
		hide-a11y-link
		hide-sitemap-link
	/>
</template>

<script setup lang="ts">
	import { LinkItem } from '@cnamts/vue-dot/src/patterns/FooterBar/types';

	const linkItems: LinkItem[] = [
		{
			text: 'Mentions légales et CGU',
			to: {
				name: window.URL_LEGAL_NOTICES
			}
		},
		{
			text: 'Gestion des cookies',
			to: {
				name: window.URL_LEGAL_NOTICES,
				hash: window.URL_CGU_COOKIES
			}
		},
		{
			text: 'Données personnelles',
			to: {
				name: window.URL_LEGAL_NOTICES,
				hash: window.URL_CGU_PERSONAL_DATA
			}
		},
		{
			text: 'Accessibilité : partiellement conforme',
			href: window.URL_ACCESSIBILITY
		}
	].filter((value) => value.to?.name !== '' && value.href !== '');

</script>